import P from 'prop-types';
import { Api } from '../../services/api';
import { useEffect, useState } from 'react';

export const ModalCanhoto = ({ id, update, isUpdated }) => {
  const [canhoto, setCanhoto] = useState(null);

  const findCanhoto = async () => {
    try {
      const resp = await Api.get(`/canhoto/${id}`);

      setCanhoto(resp.data);
      console.log('Canhoto:');
      console.log(resp.data);
    } catch (e) {
      console.log(e.message);
    } finally {
      isUpdated(false);
    }
  };

  const updateStatusCanhoto = async (id, status) => {
    try {
      Api.put(`/canhoto/update/${id}`, {
        idStatus: '' + status,
      });

      await findCanhoto();
    } catch {
      alert('Não deu certo!');
    }
  };

  useEffect(() => {
    findCanhoto();
  }, [update]);

  return (
    <div
      className="modal fade"
      id="modalValidaCanhoto"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          {canhoto && (
            <>
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Canhoto - NF {canhoto.nf}
                </h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body" style={{ height: '77vh', overflowY: 'auto' }}>
                <div className="container">
                  <div className="row">
                    <p>Data de envio: {canhoto.updatedAt}</p>
                    <img
                      src={`http://canhoto.srembalagens.com.br/${canhoto.arquivo}?a`}
                      className="img-fluid mb-2"
                      style={{ width: '100%' }}
                    />
                    <a
                      type="button"
                      className="btn btn-secondary"
                      href={`https://maps.google.com/?q=${canhoto.latitude},${canhoto.longitude}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Abrir localização no Google Maps
                    </a>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {canhoto.idStatus != 3 && (
                  <>
                    <button type="button" className="btn btn-danger" onClick={() => updateStatusCanhoto(id, 1)}>
                      Recusar
                    </button>
                    <button type="button" className="btn btn-success" onClick={() => updateStatusCanhoto(id, 3)}>
                      Aprovar
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

ModalCanhoto.propTypes = {
  id: P.number,
  update: P.bool,
  isUpdated: P.func,
};
